import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useUnitWorkloadSchool = (unitWorkloadId: number) => {
  return trpc.unit.getUnitWorkloadSchool.useQuery(
    { unitWorkloadId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!unitWorkloadId,
    },
  );
};
